import React from "react";
import AdmFollowUps from "../../components/AdminTabs/AdminAssignMentor/AdmFollowUps";

const AddStudent = () => {
  return (
    <div>
      <AdmFollowUps/>
    </div>
  );
};

export default AddStudent;
